import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RecommendationService } from '../../recommendation/recommendation.service';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { ResidentialService } from '../../residential.service';
import {
  ScrollToService,
  ScrollToConfigOptions,
} from '@nicky-lenaers/ngx-scroll-to';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-ssn-service-denied',
  templateUrl: './service-denied.component.html',
  styleUrls: ['./service-denied.component.css'],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
    trigger('flyOut', [
      state('out', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(-100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(100%)' })),
      ]),
    ]),
    trigger('flyOutans', [
      state('in', style({ transform: 'translateX(0)' })),
      transition('void => *', [
        style({ transform: 'translateX(100%)' }),
        animate(100),
      ]),
      transition('* => void', [
        animate(100, style({ transform: 'translateX(0%)' })),
      ]),
    ]),
  ],
})
export class ServiceDeniedComponent implements OnInit {
  selectedProduct;
  ssnFailedEnergyProvidersList;
  providerContact;
  servicedeniedList;
  isChecked = false;
  elem1;
  elem2;
  elem3;
  deviceWidth;
  ansinSSncheck;
  ansinSSncheck1;
  timer;
  time = 2000;
  timeTrue = false;
  hideHome = false;
  vishome;
  ansinSSncheck2;
  ansinSSncheck3;
  ansinSSncheck4;
  ansinSSncheck5;
  showDiv = false;
  GreatDiv = false;
  besureDiv = false;
  accountNumber;
  productName;
  mobileView = false;
  userObj = {
    emailId: '',
    password: '',
  };
  url = environment.api_url;
  previousUrl = '';
  url1 = '';
  oldURL = '';

  constructor(
    private router: Router,
    private recommendationService: RecommendationService,
    private residentialService: ResidentialService,
    private _scrollToService: ScrollToService,
    private http: HttpClient,
    private title: Title,
    private meta: Meta
  ) {
    if (!_.isEmpty(this.recommendationService.signupProduct)) {
      this.selectedProduct = this.recommendationService.signupProduct;
      sessionStorage.setItem(
        'signupProduct',
        JSON.stringify(this.selectedProduct)
      );
    } else {
      this.selectedProduct = JSON.parse(
        sessionStorage.getItem('signupProduct')
      );
    }
    this.getProviderInfo();
    if (!_.isEmpty(this.recommendationService.ssnFailedEnergyProviders)) {
      this.ssnFailedEnergyProvidersList =
        this.recommendationService.ssnFailedEnergyProviders;
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.ssnFailedEnergyProvidersList)
      );
    } else {
      this.ssnFailedEnergyProvidersList = JSON.parse(
        sessionStorage.getItem('ssnFailedEnergyProviders')
      );
    }
    this.servicedeniedList = {
      value1: false,
      value2: false,
      value3: false,
    };
    this.hideHome = true;
    var vishome = this.hideHome;
    sessionStorage.setItem('hideHome', JSON.stringify(vishome));
    this.deviceWidth = window.innerWidth;

    var postresult = JSON.parse(sessionStorage.getItem('postresult'));
    if (postresult != undefined) {
      this.accountNumber = postresult['data']
        ? postresult['data'].customerId
        : '';
      this.productName = postresult['data']
        ? postresult['data'].rateOfferings['ratePlanName']
        : '';
    }
  }

  onChangeRole(event) {
    this.isChecked = event.target.checked;

    if (this.deviceWidth < 768) {
      this.elem1 = document.getElementById('yes');
      this.elem2 = document.getElementById('nothankyou');
      this.elem3 = document.getElementById('thankyou');
    } else {
      this.elem1 = document.getElementById('yes');
      this.elem2 = document.getElementById('nothankyou');
      this.elem3 = document.getElementById('thankyou');
    }
    if (this.isChecked === true) {
      if (event.target.value === 'Yes') {
        this.servicedeniedList = {
          value1: true,
          value2: false,
          value3: false,
        };
        this.ansinSSncheck =
          'Yes, I remember placing something on my credit report to prevent fraud.';

        this.timer = setTimeout(() => {
          this.timeTrue = true;
          if (this.deviceWidth < 768) {
            this.GreatDiv = true;
            this.triggerScrollTo('addf_id');
          }
        }, 1000);
        this.elem1.parentElement.classList.add('active-select');
        if (_.contains(this.elem2.parentElement.classList, 'active-select')) {
          this.elem2.parentElement.classList.remove('active-select');
        }
      } else if (event.target.value === 'No, thank you') {
        this.servicedeniedList = {
          value1: false,
          value2: true,
          value3: false,
        };
        this.ansinSSncheck = 'Goodbye';
        this.ansinSSncheck1 = 'ccc';
        this.timeTrue = false;
        this.elem2.parentElement.classList.add('active-select');
        if (_.contains(this.elem1.parentElement.classList, 'active-select')) {
          this.elem1.parentElement.classList.remove('active-select');
        }
        if (this.deviceWidth < 768) {
          this.triggerScrollTo('addf_id');
        }
        this.timer = setTimeout(() => {
          this.gotoHome();
        }, this.time);
      } else if (event.target.value === 'Thank you') {
        this.servicedeniedList = {
          value1: false,
          value2: false,
          value3: true,
        };
        this.ansinSSncheck5 = 'Goodbye';

        this.elem2.parentElement.classList.add('active-select');
        if (_.contains(this.elem1.parentElement.classList, 'active-select')) {
          this.elem1.parentElement.classList.remove('active-select');
          this.elem3.parentElement.classList.remove('active-select');
        }
        if (this.deviceWidth < 768) {
          this.triggerScrollTo('secondAns_id5');
        }
        this.timer = setTimeout(() => {
          this.gotoHome();
        }, 5000);
      }
    } else {
      this.servicedeniedList = {
        value1: false,
        value2: false,
        value3: false,
      };
      this.ansinSSncheck1 = 'ccc';
      this.timeTrue = false;
      this.elem1.parentElement.classList.remove('active-select');
      this.elem2.parentElement.classList.remove('active-select');
    }
  }

  public triggerScrollTo(destination) {
    const config: ScrollToConfigOptions = {
      target: destination,
      duration: 50,
      easing: 'easeOutElastic',
    };
    this._scrollToService.scrollTo(config);
  }

  ngOnInit() {
    var ele = document.getElementById('fisrtDiv');
    this.timer = setTimeout(() => {
      this.timeTrue = true;

      if (this.deviceWidth < 768) {
        this.showDiv = true;
      }
    }, 2000);
  }

  gotoHome() {
    if (!_.isEmpty(sessionStorage.getItem('userObj'))) {
      const hg_accountId = window.location.href.split('/').pop();
      sessionStorage.removeItem('APIESIIDValues');
      sessionStorage.removeItem('esiidValue');
      sessionStorage.removeItem('recommendedProducts');
      sessionStorage.removeItem('userResponse');
      this.router.navigate(['user-settings', hg_accountId]);
    } else {
      this.router.navigate(['/']);
    }
  }
  shop(selectedOption) {
    if (selectedOption === 'prepaid') {
      this.recommendationService.ssnFailedText = selectedOption;
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders = [];
        sessionStorage.setItem(
          'ssnFailedEnergyProviders',
          JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
        );
      }
    } else {
      this.recommendationService.ssnFailedText = selectedOption;
      if (!_.isEmpty(this.ssnFailedEnergyProvidersList)) {
        this.recommendationService.ssnFailedEnergyProviders =
          this.ssnFailedEnergyProvidersList;
      }
      this.recommendationService.ssnFailedEnergyProviders.push(
        this.selectedProduct.energy_provider
      );
      sessionStorage.setItem(
        'ssnFailedText',
        this.recommendationService.ssnFailedText
      );
      sessionStorage.setItem(
        'ssnFailedEnergyProviders',
        JSON.stringify(this.recommendationService.ssnFailedEnergyProviders)
      );
    }
    this.router.navigate([
      'recommendation/compare-product',
      this.recommendationService.hg_accountId,
    ]);
  }

  getProviderInfo() {
    this.residentialService
      .getProviderContactInfoDetails(
        this.selectedProduct.energy_provider,
        this.selectedProduct.utility_name
      )
      .subscribe((res: any) => {
        this.providerContact = res[0];
      });
  }

  gotoUnfreezemyCredit() {
    window.open('https://www.experian.com/ncaconline/removefreeze', '_blank');
    if (this.deviceWidth > 768) {
      this.router.navigate([
        'thankyou',
        this.recommendationService.hg_accountId,
      ]);
    } else if (this.deviceWidth < 768) {
      this.mobileView = true;
      this.timer = setTimeout(() => {
        this.timeTrue = true;
        this.ansinSSncheck3 = 'Okay, I’m back!';
        this.besureDiv = true;
        if (this.deviceWidth < 768) {
          this.triggerScrollTo('ansinSSncheck3div');
        }
      }, this.time);
    }
  }

  clickOnLink() {
    window.open('https://www.transunion.com/credit-freeze', '_blank');
    this.ansinSSncheck2 = 'Brb, going to unfreeze';

    this.timer = setTimeout(() => {
      this.timeTrue = true;
      this.ansinSSncheck3 = 'Okay, I’m back!';
      this.besureDiv = true;
      if (this.deviceWidth < 768) {
        this.triggerScrollTo('ansinSSncheck3div');
      }
    }, this.time);
  }

  clickOnMobile() {
    this.ansinSSncheck4 =
      'Dialing ' + this.providerContact.customerDeposit_enquiry;
    this.timer = setTimeout(() => {
      this.timeTrue = true;

      if (this.deviceWidth < 768) {
        this.triggerScrollTo('thankAnsDail');
      }
    }, this.time);
  }

  createAccount(event, myForm) {
    const body = new HttpParams();
    body.append('userObj', JSON.stringify(this.userObj));
    body.append('a', 'login');
    this.http
      .get(this.url + '/login', { params: body })
      .subscribe((res: any) => {
        const result = res;
        if (result.statusCode === '002') {
          this.userObj.emailId = '';
          this.userObj.password = '';
        } else {
          this.setAdminTitle(result.data.userRole);
          this.saveQuestionnaireObject(
            sessionStorage.getItem('userResponse'),
            result.data
          );
          myForm.resetForm();
          sessionStorage.setItem('userObj', JSON.stringify(result.data));
          this.oldURL = sessionStorage.getItem('path');
          this.checkUserRoles(result.data);
        }
      });
  }

  saveQuestionnaireObject(questionnarieObj, data) {
    //const body = new HttpParams();
    let percentage = sessionStorage.getItem('percentage');
    if (questionnarieObj && data) {
      // body.append('questionnarieObj', questionnarieObj);
      // body.append('userObj', JSON.stringify(data));
      // body.append('percentage', percentage);

      const body = new HttpParams()
      .append('questionnarieObj', questionnarieObj)
      .append('userObj', JSON.stringify(data))
      .append('percentage', percentage);

      this.http
        .post(this.url + '/saveQuestions', body)
        .subscribe((res: any) => {
          console.log(res);
        });
    }
  }

  checkUserRoles(result: any) {
    if (result.userRole === 'Admin') {
      this.router.navigate(['hg-admin']);
    } else {
      this.router.navigate(['signuporder', result.hg_accountId]);
      this.recommendationService.userName = result.questionStatusObj
        ? result.questionStatusObj.userName
          ? result.questionStatusObj.userName
          : null
        : null;
      this.residentialService.setUser({
        userName: result.userName,
        accountId: result.hg_accountId,
        emailId: result.userDetails.emailId,
      });
      this.residentialService.userResponse.userResponses = result.userResponses;
      this.residentialService.questionnaireStatusObj = result.questionStatusObj;
      this.residentialService.filter(result.userResponses);
      this.residentialService.currentId = result.questionStatusObj.questionStep;
      this.residentialService.messageService({
        nextId: result.questionStatusObj.questionStep,
        questionStatus: result.questionStatusObj.questionStatus,
        responses: result.userResponses,
      });
    }
  }
  setAdminTitle(userRole: any) {
    if (userRole === 'Admin') this.title.setTitle('Admin Dashboard');
  }
}
